var _circle, _path, _rect, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8WearHelmetAndFaceShield50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#1565c0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32.979,39c-0.001,0-0.002,0-0.003,0c-5.348-0.005-8.627-1.694-10.437-3.111 C21.562,35.123,21,33.973,21,32.732V20h2v12.732c0,0.621,0.281,1.197,0.772,1.582c1.279,1.001,4.176,2.681,9.206,2.686h0.001 c0.275,0,0.533-0.104,0.727-0.293C33.896,36.522,34,36.275,34,36.012V20h2v16.012c0,0.807-0.318,1.562-0.896,2.126 C34.535,38.694,33.78,39,32.979,39z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 3,
    x: 11,
    y: 24,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.862,18.043C31.147,12.714,27.474,8,20.5,8C12.68,8,9,13.925,9,20v1h28v-1L31.862,18.043z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12,22c0-0.48,0.027-1.187,0.122-2h-2.017C10.042,20.644,10,21.305,10,22 c0,5.021,1.491,7.787,2.688,10.01C13.421,33.369,14,34.443,14,35.676V38h2v-2.324c0-1.737-0.753-3.135-1.551-4.615 C13.301,28.931,12,26.516,12,22z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31,22.874V22c0-0.683-0.068-1.348-0.173-2h-2.018C28.934,20.646,29,21.315,29,22v1.376l1.936,3.606 l0.09,0.101c-0.093,0.04-1.41,0.589-1.41,0.589L29,27.928v4.381C29,33.793,27.771,35,26.262,35H24.5v2h1.762 C28.874,37,31,34.896,31,32.309v-3.048c0.401-0.168,0.85-0.355,0.851-0.356c0.473-0.222,0.835-0.617,1.019-1.108 c0.227-0.599,0.152-1.268-0.194-1.802L31,22.874z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8WearHelmetAndFaceShield50);
export default __webpack_public_path__ + "static/media/icons8-wear-helmet-and-face-shield-50.228c3d38884a40f3748762e19abe0cbc.svg";
export { ForwardRef as ReactComponent };